exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-checkbox-group[data-v-3f4f5dda]{display:inline-flex;flex-wrap:wrap}\n", ""]);

// exports
